export * from "./manage-authorities";
